import { render, staticRenderFns } from "./MeetingDocumentSidebar.vue?vue&type=template&id=490d251c"
import script from "./MeetingDocumentSidebar.vue?vue&type=script&lang=js"
export * from "./MeetingDocumentSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports